import Vue from 'vue';

class ConsoleHelperDefinition extends Vue 
{
    private development: boolean = process.env.NODE_ENV === 'development';

    get log() {
        return console.log;
    }
    
    get warn() {
        return console.warn;
    }
    
    get debugLog() {
        if (this.development) {
            return console.log;
        }
        // tslint:disable-next-line:no-empty
        return () => { };
    }
    
    get debugWarn() {
        if (this.development) {
            return console.warn;
        }
        // tslint:disable-next-line:no-empty
        return () => { };
    }
}

export const Consoler = new ConsoleHelperDefinition();